import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Calculator from '../components/Calculator';
import ScoreReadout from '../components/ScoreReadout';
import Bridge from '../components/Bridge';
import LinksDoctorNote from '../components/LinksDoctorNote';
import DoutoResultCta from '../components/DoutoResultCta';
import GuideNavigator from '../components/GuideNavigator';
import Editorial from '../components/Editorial';
import RelatedScales from '../components/RelatedScales';
import FAQ from '../components/FAQ';
import Conversion from '../components/Conversion';
import ReferencesAndAuthor from '../components/ReferencesAndAuthor';
import Footer from '../components/Footer';

const guides = [
  { to: '/tabela', label: 'Tabela da Escala de Glasgow', text: 'Critérios O, V e M lado a lado para consulta rápida.' },
  { to: '/pediatrica', label: 'Glasgow pediátrica', text: 'Adaptações da resposta verbal e avaliação em lactentes e crianças.' },
  { to: '/ecg-p', label: 'ECG-P e pupilas', text: 'Entenda como a reatividade pupilar complementa o escore clássico.' },
  { to: '/como-avaliar', label: 'Como avaliar', text: 'Sequência prática, estímulos e registro dos componentes.' },
];

function Home() {
  const [severity, setSeverity] = useState(null);
  const [selections, setSelections] = useState({ eye: null, verbal: null, motor: null, pupils: null });

  const handleCalculatorChange = (newSelections) => {
    setSelections(newSelections);
  };

  return (
    <>
      <Header />

      <main>
        <div className="page above-fold-shell editorial-grid">
          <Hero />

          <section className="calculator-section glasgow-hero-tool wide" id="calculadora" aria-labelledby="calculator-title">
            <div className="calculator-section__intro">
              <div>
                <span className="section-kicker">Calculadora clínica</span>
                <h2 id="calculator-title">Calcule a Escala de Glasgow</h2>
              </div>
              <p>Selecione a melhor resposta observada em cada componente. O resultado aparece ao lado no desktop e logo abaixo no celular.</p>
            </div>

            <div className="calc">
              <div className="calc__main">
                <Calculator onSelectionsChange={handleCalculatorChange} />
              </div>
              <ScoreReadout selections={selections} onSeverityChange={setSeverity} />
            </div>
            {Boolean(severity) && <DoutoResultCta />}
            <LinksDoctorNote show={Boolean(severity)} source="adulto" />
          </section>
        </div>

        <Bridge severity={severity} />

        <div className="page editorial editorial-grid">
          <GuideNavigator guides={guides} />
          <Editorial />
          <RelatedScales />
          <FAQ />
          <Conversion />
          <ReferencesAndAuthor />
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Home;
